import Axios from "axios";
import {
  GET_PRODUCTS,
  CLEAR_ERRORS,
  GET_ERRORS,
  LOADING_PRODUCTS
} from "./types";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;


export const getProducts = (page, pageCount,filter) => dispatch => {
  dispatch(setProductsLoading());
  Axios.get(`/api/v1/products?page=${page}&per_page=${pageCount}${filter}`)
    .then(res => {
      dispatch({
        type: GET_PRODUCTS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
};



export const setProductsLoading = () => {
  return {
    type: LOADING_PRODUCTS
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
